

<div class="user-details h-screen flex flex-col p-4 box-border" *ngIf="canAccess">
  <p-toast />
  <!-- Toolbar -->
  <p-toolbar styleClass="mb-4">
    <ng-template #start>
      <div class="toolbar-actions">
      <p-button label="New user" icon="pi pi-plus" severity="secondary" (click)="openRegisterDialog()" />
      <!-- <p-button label="Reset Password" icon="pi pi-key" severity="secondary" class="mr-2"
        (click)="openResetPasswordDialogFromSelection()" [disabled]="!selectedUsers || selectedUsers.length !== 1" /> -->
      <p-button label="Assign Role" icon="pi pi-plus" severity="secondary"
        [disabled]="!selectedUsers || selectedUsers.length === 0" (click)="openAssignRoleDialog()" />
        <p-button
        label="Remove Role"
        icon="pi pi-minus"
        severity="secondary"
        [disabled]="!selectedUsers || selectedUsers.length !== 1"
        (click)="openRemoveRoleDialog()"
      ></p-button>
      <p-button label="Disable" icon="pi pi-ban" severity="secondary" outlined (onClick)="disableSelectedUsers()"
        [disabled]="isDisableButtonDisabled()"></p-button>
      <p-button label="Enable" icon="pi pi-check" severity="secondary" outlined (onClick)="enableSelectedUsers()"
        [disabled]="isEnableButtonDisabled()"></p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="end"> <p-button label="Back" icon="pi pi-arrow-left" severity="secondary"
        (onClick)="goBack()"></p-button></ng-template>
  </p-toolbar>

  <p-dialog [(visible)]="assignRoleDialog" [style]="{ width: '400px' }" header="Assign Role Group" [modal]="true">
    <div *ngIf="isLoadingRoles" style="text-align:center;">
      <p-progressSpinner></p-progressSpinner>
      <p>Loading role groups...</p>
    </div>
    <div *ngIf="!isLoadingRoles">
      <p-listbox [options]="roleGroupSuggestions" [(ngModel)]="selectedRoleGroups" optionLabel="name" [multiple]="true"
        [style]="{ width: '100%' }" [listStyle]="{ maxHeight: '200px' }" placeholder="Select role group(s)">
      </p-listbox>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Assign" icon="pi pi-check" (click)="assignRoleGroups()"
        [disabled]="isLoadingRoles || !selectedRoleGroups.length"></button>
      <button pButton label="Cancel" icon="pi pi-times" (click)="assignRoleDialog = false"
        class="p-button-secondary"></button>
    </ng-template>
  </p-dialog>

  <!-- Remove Role Group Dialog -->
  <p-dialog [(visible)]="removeRoleDialog" [style]="{ width: '400px' }"
    [header]="'Remove Role – ' + (selectedUsers?.[0]?.userName || 'User')" [modal]="true">
    <div *ngIf="!userRoleGroupsForSelected?.length">
      <p>No role groups assigned to this user.</p>
    </div>
    <div *ngIf="userRoleGroupsForSelected?.length">
      <p-listbox
        [options]="userRoleGroupsForSelected"
        [(ngModel)]="selectedRoleGroupsToRemove"
        optionLabel="name"
        [style]="{ width: '100%' }"
        [listStyle]="{ maxHeight: '200px' }"
        [multiple]="true"
      >
      </p-listbox>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        label="Remove"
        icon="pi pi-check"
        (click)="confirmRemoveSelectedRoleGroup()"
        [disabled]="!selectedRoleGroupsToRemove.length"
      ></button>
      <button
        pButton
        label="Cancel"
        icon="pi pi-times"
        (click)="removeRoleDialog = false"
        class="p-button-secondary"
      ></button>
    </ng-template>
  </p-dialog>

  <p-contextMenu #rowContextMenu [model]="rowContextMenuItems"></p-contextMenu>

  <!-- Table Box -->
  <div class="table-box flex-1 overflow-auto" style="width: 100%;">
    <div style="min-width: 1200px; width: max-content;">
      <p-table #dt [value]="registeredUsers" [(selection)]="selectedUsers" selectionMode="multiple" dataKey="id"
        [rows]="20" [paginator]="true" [rowsPerPageOptions]="[20,40,60]"
        [globalFilterFields]="['firstName', 'lastName','email','mobileNumber','password']"
        [style]="{ minWidth: '1500px', width: '100%' }" [rowHover]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users" [showCurrentPageReport]="true"
        [responsiveLayout]="'scroll'">

        <ng-template #caption>
          <div class="flex items-center justify-between">
            <h5 class="m-0">Registered Users</h5>
            <p-iconfield>
              <p-inputicon styleClass="pi pi-search" />
              <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Search..." />
            </p-iconfield>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              <p-confirmDialog></p-confirmDialog>
            </th>
            <th pSortableColumn="id">ID <p-sortIcon field="id"></p-sortIcon></th>
            <th pSortableColumn="userName">User Name <p-sortIcon field="userName"></p-sortIcon></th>
            <th pSortableColumn="firstName">First Name <p-sortIcon field="firstName"></p-sortIcon></th>
            <th pSortableColumn="middleName">Middle Name <p-sortIcon field="middleName"></p-sortIcon></th>
            <th pSortableColumn="lastName">Last Name <p-sortIcon field="lastName"></p-sortIcon></th>
            <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
            <th pSortableColumn="mobile">Mobile <p-sortIcon field="mobile"></p-sortIcon></th>
            <th pSortableColumn="company">Company <p-sortIcon field="company"></p-sortIcon></th>
            <th pSortableColumn="division">Division <p-sortIcon field="division"></p-sortIcon></th>
            <th pSortableColumn="facility">Facility <p-sortIcon field="facility"></p-sortIcon></th>
            <th pSortableColumn="warehouse">Warehouse <p-sortIcon field="warehouse"></p-sortIcon></th>
            <th pSortableColumn="m3ResponsibleId">m3ResponsibleId <p-sortIcon field="m3ResponsibleId"></p-sortIcon></th>
            <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>

            <th pSortableColumn="createdAt">Created At <p-sortIcon field="createdAt"></p-sortIcon></th>


            <!-- <th pSortableColumn="sub">Sub <p-sortIcon field="sub"></p-sortIcon></th> -->
            <!-- <th>Actions</th> -->
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user>
          <tr [class.disabled-user]="user.isActive === false" [pSelectableRow]="user"
              (contextmenu)="onRowContextMenu($event, user)">
            <td><p-tableCheckbox [value]="user"></p-tableCheckbox></td>
            <td>{{ user.id }}</td>
            <td>{{ user.userName }}</td>
            <td>{{ user.firstName }}</td>
            <td>{{ user.middleName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.mobile }}</td>
            <td>{{ user.company }}</td>
            <td>{{ user.division }}</td>
            <td>{{ user.facility }}</td>
            <td>{{ user.warehouse }}</td>
            <td>{{ user.m3ResponsibleId }}</td>
            <td>{{ user.status }}</td>
            <td>{{ user.createdAt | date:'short' }}</td>


            <!-- <td>{{ user.sub }}</td> -->
            <!-- <td>
              <p-button icon="pi pi-pencil" (click)="editUser(user)" [rounded]="true" [outlined]="true"></p-button>
            </td> -->
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>

  <!-- Registration Dialog -->
  <p-dialog [(visible)]="registerDialog" [style]="{ width: '500px' }" header="Register" [modal]="true"
    [closable]="false">
    <ng-template pTemplate="content">
      <!-- First Name -->
      <div class="mb-3">
        <label class="block font-bold mb-2">First Name</label>
        <input type="text" pInputText [(ngModel)]="registerData.firstName" class="w-full" tabindex="1" #firstNameInput
          (keydown.enter)="middleNameInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.firstName">First name is required.</small>
      </div>

      <!-- Middle Name -->
      <div class="mb-3">
        <label class="block font-bold mb-2">Middle Name</label>
        <input type="text" pInputText [(ngModel)]="registerData.middleName" class="w-full" tabindex="2" #middleNameInput
          (keydown.enter)="lastNameInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.middleName">Middle name is required.</small>
      </div>

      <!-- Last Name -->
      <div class="mb-3">
        <label class="block font-bold mb-2">Last Name</label>
        <input type="text" pInputText [(ngModel)]="registerData.lastName" class="w-full" tabindex="3" #lastNameInput
          (keydown.enter)="emailInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.lastName">Last name is required.</small>
      </div>

      <!-- Email -->
      <div class="mb-3">
        <label class="block font-bold mb-3">Email</label>
        <input type="email" pInputText [(ngModel)]="registerData.email" class="w-full" tabindex="4" #emailInput
          (keydown.enter)="userNameInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.email">Email is required.</small>
      </div>

      <!-- Username -->
      <div class="mb-3">
        <label class="block font-bold mb-2">Username</label>
        <input type="text" pInputText [(ngModel)]="registerData.userName" class="w-full" tabindex="5" #userNameInput
          (keydown.enter)="mobileNumberRawInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.userName">Username is required.</small>
      </div>

      <!-- Mobile Number -->
      <div class="mb-3">
        <label class="block font-bold mb-2">Mobile Number</label>
        <div class="flex">
          <select [(ngModel)]="registerData.countryCode" class="border rounded-l px-2 py-1"
            style="width: 90px; min-width: 60px; max-width: 100px;" tabindex="6" #countryCodeInput
            (keydown.enter)="mobileNumberRawInput.focus()">
            <option value="+91">🇮🇳 +91 (India)</option>
            <option value="+49">🇩🇪 +49 (Germany)</option>
            <option value="+31">🇳🇱 +31 (Netherlands)</option>
          </select>
          <input type="text" pInputText [(ngModel)]="registerData.mobileNumber" class="w-full rounded-r"
            style="border-left: 0" tabindex="7" #mobileNumberRawInput (keydown.enter)="companyInput.focus()" />
        </div>
        <small class="text-red-500" *ngIf="submitted && !registerData.mobileNumber">Mobile number is required.</small>
      </div>

      <!-- Company Field -->
      <div class="mb-3">
        <label for="company" class="block font-bold mb-2">Company</label>
        <input id="company" type="text" pInputText [(ngModel)]="registerData.company" class="w-full" tabindex="8"
          #companyInput (keydown.enter)="divisionInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.company">Company is required.</small>
      </div>

      <!-- Division Field -->
      <div class="mb-3">
        <label for="division" class="block font-bold mb-2">Division</label>
        <input id="division" type="text" pInputText [(ngModel)]="registerData.division" class="w-full" tabindex="9"
          #divisionInput (keydown.enter)="facilityInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.division">Division is required.</small>
      </div>

      <!-- Facility Field -->
      <div class="mb-3">
        <label for="facility" class="block font-bold mb-2">Facility</label>
        <input id="facility" type="text" pInputText [(ngModel)]="registerData.facility" class="w-full" tabindex="10"
          #facilityInput (keydown.enter)="warehouseInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.facility">Facility is required.</small>
      </div>

      <!-- Warehouse Field -->
      <div class="mb-3">
        <label for="warehouse" class="block font-bold mb-2">Warehouse</label>
        <input id="warehouse" type="text" pInputText [(ngModel)]="registerData.warehouse" class="w-full" tabindex="11"
          #warehouseInput (keydown.enter)="m3ResponsibleIdInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.warehouse">Warehouse is required.</small>
      </div>

       <!-- Warehouse Field -->
      <div class="mb-3">
        <label for="m3ResponsibleId" class="block font-bold mb-2">m3ResponsibleId</label>
        <input id="m3ResponsibleId" type="text" pInputText [(ngModel)]="registerData.m3ResponsibleId" class="w-full" tabindex="11"
          #m3ResponsibleIdInput (keydown.enter)="passwordInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.m3ResponsibleId">m3ResponsibleId is required.</small>
      </div>

      <!-- Password -->
      <div class="mb-3">
        <label class="block font-bold mb-2">Password</label>
        <input type="password" pInputText [(ngModel)]="registerData.password" class="w-full" tabindex="12"
          #passwordInput (keydown.enter)="reEnteredPasswordInput.focus()" />
        <small class="text-red-500" *ngIf="submitted && !registerData.password">Password is required.</small>
      </div>

      <!-- Re-enter Password -->
      <div class="mb-3">
        <label class="block font-bold mb-2">Re-enter Password</label>
        <input type="password" pInputText [(ngModel)]="reEnteredPassword" class="w-full" tabindex="13"
          #reEnteredPasswordInput (keydown.enter)="onRegisterClick()" />
        <small class="text-red-500" *ngIf="submitted && registerData.password !== reEnteredPassword">
          Passwords do not match.
        </small>
      </div>


    </ng-template>

    <ng-template pTemplate="footer">
      <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()"></p-button>
      <p-button label="Register" icon="pi pi-check" tabindex="14" #registerButton (click)="onRegisterClick()"
        type="button"></p-button>
    </ng-template>
  </p-dialog>

  <!-- No Data Template -->
  <ng-template #noData>
    <div class="flex flex-col items-center justify-center h-full text-center text-gray-500">
      <h2>No Registered Users Yet</h2>
      <p>Please go back and fill out the registration form.</p>
    </div>
  </ng-template>

  <!-- Reset Password Dialog -->
  <p-dialog header="Reset Password" [(visible)]="resetPasswordDialog" [modal]="true" [closable]="false"
    [style]="{ width: '400px' }">
    <ng-template pTemplate="content">
      <div class="mb-3">
        <label for="email" class="block font-bold mb-2">Enter Email ID</label>
        <input type="email" id="email" pInputText [(ngModel)]="resetEmail" class="w-full"
          placeholder="example@email.com" />
        <small class="text-red-500" *ngIf="resetPasswordSubmitted && !resetEmail">Email is required.</small>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" class="mr-2"
        (click)="resetPasswordDialog = false"></p-button>
      <p-button label="Send Link" icon="pi pi-envelope" (click)="sendResetLink()" type="button"></p-button>
    </ng-template>
  </p-dialog>
</div>

<style>
  .user-details {
    max-width: 100%;
    width: 100%;
  }

  .table-box {
    border-radius: 8px;
    box-shadow: 0 1px 6px rgb(0 0 0 / 0.1);
    padding: 1rem;
    overflow-x: auto;
    height: 100%;
  }

  .disabled-user {
    opacity: 0.6;
    text-decoration: line-through;
    color: gray;
  }

  .toolbar-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  @media screen and (max-width: 768px) {
    .table-box {
      padding: 0.5rem;
    }
  }

  /* Step 2: Add styles for the loader overlay */
  .loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
</style>